import type { GoalCollectionModel } from "@/features/collections/api/models/GoalCollectionModel";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface GoalCollectionResponseModel {
	readonly goalCollection: GoalCollectionModel | null;
}

export const useGoalCollection = (collectionId: string) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["goalCollection", collectionId],
		queryFn: () => http<GoalCollectionResponseModel>({
			method: "GET",
			url: `/collection/${collectionId}/goal-collection`
		})
	});
};
